export default __webpack_public_path__ + "static/media/15.40c97235.jpg";